module.exports = __webpack_public_path__ + "static/media/calendar.d49cf65b.svg";